// extracted by mini-css-extract-plugin
export default {"container":"CreateLastMinuteDeal_container__5Li7P","popup":"CreateLastMinuteDeal_popup__A09en","btnWrapper":"CreateLastMinuteDeal_btnWrapper__THt-e"};